module.exports = __webpack_public_path__ + "static/timekeeping-logo-a9e0b326d7fde2ade1ab0cac8d263fde.png";